import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { State } from "./types";
import { getProjectState } from "./utils";

function handleRequest(
  state: State,
  data: Boundaries["retrieveLists"]["request"],
): State {
  const { index, result } = getProjectState(state, data);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...result, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { ...result, request: setRequestStateToPending() }];
}

export { handleRequest };
